export enum PrimaryButtonType {
    LOADING = 'Loading',
    PLAY = 'Play',
    UNAVAILABLE = 'Unavailable',
    PURCHASE = 'Purchase',
    NONE = 'None',
}
